export default __webpack_public_path__ + "static/media/BFA.13b02b55.svg";